import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LogoMark } from "@/components/AppLayout";

const TOOLS = [
  { path: "/tools/ai-governance-maturity", label: "AI Governance Maturity" },
  { path: "/tools/contributor-class-classifier", label: "Contributor Class Classifier" },
  { path: "/tools/policy-checker", label: "Policy Checker" },
  { path: "/tools/review-sla-calculator", label: "Review SLA Calculator" },
  { path: "/tools/revocation-risk", label: "Revocation Risk Score" },
];

export default function ToolLayout({ children }) {
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Top nav */}
      <header className="border-b border-border/80 sticky top-0 bg-background/95 backdrop-blur z-10">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <LogoMark />
            <span className="font-serif-display text-lg">ProofMark</span>
          </Link>
          <div className="flex items-center gap-5">
            <Link
              to="/tools"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              All tools
            </Link>
            <Link
              to="/app"
              className="bg-brand text-brand-foreground text-sm px-3.5 py-1.5 rounded-md hover:opacity-90 transition-opacity"
            >
              Open app →
            </Link>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-5xl mx-auto px-6 py-12">{children}</main>

      {/* Footer — cross-links */}
      <footer className="border-t border-border/80 mt-16 bg-muted/30">
        <div className="max-w-5xl mx-auto px-6 py-10">
          <p className="tracked-caps mb-5">More free tools</p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {TOOLS.filter((t) => t.path !== pathname).map((t) => (
              <Link
                key={t.path}
                to={t.path}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {t.label} →
              </Link>
            ))}
            <Link
              to="/blog"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Blog →
            </Link>
            <Link
              to="/"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              ProofMark product →
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
